import range from "lodash/range";
import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-wrapper"
  }, range(0, this.attr(`num-rows`)).map((_) => /* @__PURE__ */ jsx("div", {
    class: { [`mp-skeleton-${this.attr(`row-size`)}`]: true }
  })));
}
